import React, {useEffect, useState} from 'react'
import ActionButton from "../seat/action/Action";
import Space from "../../base/space/Space";
import RaiseBar, {RAISE_STEP} from "../seat/raise/Raise";
import DelayedInput from "../../base/delayedinput/DelayedInput";
import './Actions.css';
import {formatValue} from "../../../utils/Formatter";
import {HiCheck, HiX} from "react-icons/hi";
import RadioButton from "../../base/radiobutton/RadioButton";


const Actions = ({
                     isPlaying,
                     showCall,
                     callValue,
                     minRaise,
                     maxRaise,
                     bigBlind,
                     pot,
                     isPreflop,
                     allPlayersAllIn,
                     onCheckClick,
                     onRaiseClick,
                     onCallClick,
                     onFoldClick,
                     showAutoFold,
                     isAutoFoldChecked,
                     onAutoFoldClick,
                     showAutoCheck,
                     isAutoCheckChecked,
                     onAutoCheckClick,
                     showAutoCall,
                     isAutoCallChecked,
                     onAutoCallClick,
                     showAutoCallAny,
                     isAutoCallAnyChecked,
                     onAutoCallAnyClick,
                 }) => {

    const [amount, setAmount] = useState(minRaise);
    const [sliderVisible, setSliderVisible] = useState(false);

    useEffect(() => {
        setAmount(minRaise);
    }, [minRaise])

    const buildAutoCheckRadio = () => {
        if (!showAutoCheck) return null;

        return (
            <RadioButton checked={isAutoCheckChecked} text={"Check"} onClick={onAutoCheckClick}/>
        )
    }

    const buildAutoCallRadio = () => {
        if (!showAutoCall) return null;

        let callText = "Call";
        if (callValue) callText += " " + formatValue(callValue, "")
        return (
            <RadioButton checked={isAutoCallChecked} text={callText} onClick={onAutoCallClick}/>
        )
    }

    const buildAutoCallAnyRadio = () => {
        if (!showAutoCallAny) return null;

        return (
            <RadioButton checked={isAutoCallAnyChecked} text={"Call any"} onClick={onAutoCallAnyClick}/>
        )
    }


    const buildAutoFoldRadio = () => {
        if (!showAutoFold) return null;

        return (
            <RadioButton checked={isAutoFoldChecked} text={"Fold"} onClick={onAutoFoldClick}/>
        )
    }

    const buildCheckButton = () => {
        if (!showCall) {
            return (
                <ActionButton style="MainActionButton" text={"Check"} onClick={() => {
                    onCheckClick();
                }}/>
            )
        }

        const callAmount = Math.min(callValue, maxRaise);
        let callButtonStr = "Call";
        if (callAmount) callButtonStr += " " + formatValue(callAmount, "")
        return (
            <ActionButton style="MainActionButton" text={callButtonStr} onClick={() => {
                onCallClick();
            }}/>
        )
    }

    const buildBetButton = () => {
        let enabled = true;
        if (minRaise >= maxRaise || allPlayersAllIn) enabled = false;

        if (!showCall) {
            return (
                <ActionButton style="MainActionButton" text={"Bet"} enabled={enabled} onClick={() => {
                    setSliderVisible(true);
                }}/>
            )
        }

        return (
            <ActionButton style="MainActionButton" text={"Raise"} enabled={enabled} onClick={() => {
                setSliderVisible(true);
            }}/>
        )
    }

    const buildFoldButton = () => {
        return (
            <ActionButton style="MainActionButton ActionRedBg" text={"Fold"} onClick={() => {
                onFoldClick();
            }}/>
        )
    }

    const build13Button = () => {
        const value = pot / 3;

        let enabled = true;
        if (value < minRaise || value > maxRaise) enabled = false;

        return (
            <ActionButton style={"SmallActionButton"} enabled={enabled} text={"1/3"} onClick={() => {
                setAmount(value);
            }}/>
        )
    }


    const build12Button = () => {
        const value = pot / 2;

        let enabled = true;
        if (value < minRaise || value > maxRaise) enabled = false;

        return (
            <ActionButton style={"SmallActionButton"} enabled={enabled} text={"1/2"} onClick={() => {
                setAmount(value);
            }}/>
        )
    }

    const build23Button = () => {
        const value = pot / 3 * 2;

        let enabled = true;
        if (value < minRaise || value > maxRaise) enabled = false;

        return (
            <ActionButton style={"SmallActionButton"} enabled={enabled} text={"2/3"} onClick={() => {
                setAmount(value);
            }}/>
        )
    }

    const build2xButton = () => {
        const value = bigBlind * 2;

        let enabled = true;
        if (value < minRaise || value > maxRaise) enabled = false;

        return (
            <ActionButton style={"SmallActionButton"} enabled={enabled} text={"2 BB"} onClick={() => {
                setAmount(value);
            }}/>
        )
    }

    const build25xButton = () => {
        const value = bigBlind * 2.5;

        let enabled = true;
        if (value < minRaise || value > maxRaise) enabled = false;

        return (
            <ActionButton style={"SmallActionButton"} enabled={enabled} text={"2.5 BB"} onClick={() => {
                setAmount(value);
            }}/>
        )
    }

    const build3xButton = () => {
        const value = bigBlind * 3;

        let enabled = true;
        if (value < minRaise || value > maxRaise) enabled = false;

        return (
            <ActionButton style={"SmallActionButton"} enabled={enabled} text={"3 BB"} onClick={() => {
                setAmount(value);
            }}/>
        )
    }

    const build5xButton = () => {
        const value = bigBlind * 5;

        let enabled = true;
        if (value < minRaise || value > maxRaise) enabled = false;

        return (
            <ActionButton style={"SmallActionButton"} enabled={enabled} text={"5 BB"} onClick={() => {
                setAmount(value);
            }}/>
        )
    }


    const buildPotButton = () => {
        let enabled = true;
        if (pot < minRaise || pot > maxRaise || pot === 0) enabled = false;

        return (
            <ActionButton style={"SmallActionButton"} enabled={enabled} text={"Pot"} onClick={() => {
                setAmount(pot);
            }}/>
        )
    }

    const round2Decimals = (value) => {
        return Math.round(value * 100) / 100
    }

    const onAcceptRaise = () => {
        if (amount < minRaise) return;

        onRaiseClick(amount);
        onCloseRaise();
    }

    const onCloseRaise = () => {
        setAmount(minRaise);
        setSliderVisible(false);
    }

    const onSliderChanged = (value) => {
        setAmount(value);
    }

    const onInputChanged = (event) => {
        let val = event.target.value
        if (val) setAmount(val * 1000000);
    }

    let sliderMax = maxRaise + RAISE_STEP;
    // if (maxRaise > minRaise) {
    //     sliderMax += RAISE_STEP;
    // }

    return <div className="ActionsRoot">
        {
            (() => {
                if (!isPlaying) {
                    return <div className="FutureActions">
                        {buildAutoCheckRadio()}
                        {buildAutoCallRadio()}
                        {buildAutoCallAnyRadio()}
                        {buildAutoFoldRadio()}
                    </div>
                }

                if (sliderVisible) {
                    return <div className="RaiseTools">
                        <div className="RaiseActions">
                            {
                                (() => {
                                    if (!isPreflop) {
                                        return <div className="RaiseButtons">
                                            {build13Button()}
                                            {build12Button()}
                                            {build23Button()}
                                            {buildPotButton()}
                                        </div>
                                    } else {
                                        return <div className="RaiseButtons">
                                            {build2xButton()}
                                            {build25xButton()}
                                            {build3xButton()}
                                            {build5xButton()}
                                        </div>
                                    }
                                })()
                            }
                            <Space space={8}/>
                            <div className="RaiseSlider">
                                <RaiseBar value={amount} onValueChanged={onSliderChanged} min={minRaise}
                                          max={sliderMax}/>
                            </div>
                        </div>
                        <Space space={8}/>
                        <DelayedInput style="RaiseInput" type={"number"} value={round2Decimals(amount / 1000000)}
                                      onChange={onInputChanged}/>
                        <Space space={8}/>
                        <ActionButton style={"MediumActionButton"} icon={<HiCheck size={20} color={"#d1d4d7"}/>}
                                      onClick={onAcceptRaise}/>
                        <ActionButton style={"MediumActionButton"} icon={<HiX size={20} color={"#d1d4d7"}/>}
                                      onClick={onCloseRaise}/>
                    </div>
                }

                return <div className="MainActions">
                    {buildCheckButton()}
                    {buildBetButton()}
                    {buildFoldButton()}
                </div>
            })()
        }

    </div>
}

export default Actions;

